export const SIZE_TAB = {
  MY_PURCHASE: 'my_purchase',
  DIRECT_INPUT: 'direct_input',
} as const;

export type ActualSizeTabName = (typeof SIZE_TAB)[keyof typeof SIZE_TAB];

export type SizeInfoItem = {
  imageUrl: string;
  headers: string[]; // 테이블 헤더 (예: ["사이즈", "총기장", "가슴단면"...])
  rows: string[][]; // 테이블 데이터 행 (예: [["FREE", "66", "57"...], ["S", "65", "55"...]])
  description: string[];
  sizeCategoryId?: string;
  isSizeComparable?: boolean;
  highlightFlags?: boolean[][]; // [row][col]
  mostSimilarIndex?: number;
  hasCompareRow?: boolean;
};
